import { ProductMaster } from "../../../../hooks/useProductMaster";
import {
  IGlobalProduct,
  IPisRequest,
  IRequestorMarket,
  ISkuComposition,
  ISkuInformation,
  ITcc,
  ITccComposition,
  TccCompositionRegionInfo,
} from "../../../../types/data.interface";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "react-tooltip";
import { useLinePlanningStatusConditionsContext } from "context/LinePlanningStatusConditionsContext";
import { LIFECYCLE_STATUS_LABEL, PRODUCTION_STATUS_LABEL, SALES_STATUS_LABEL, } from "constants/labels";
import { useCreateMpnStore } from "../../context/create/CreateMpnContext";
import { calculateLinePlanningStatus } from "../../../../helpers/line-planning-status.helper";
import { formatTpsTypeIntoOption } from "helpers/tps-type.helper";
import { formatSupplierCountryIntoOption } from "../../../../helpers/supplier-country.helper";
import { numberOfTextAreaRows } from "../../../../helpers";
import { isMpnCompositionEmpty } from "./mpn-create.helper";
import MpnCompositionTree from "../../components/mpn-composition-tree/MpnCompositionTree";
import {
  fusionSupplier,
  fusionSupplierOptions,
} from "../../../../constants/fusionSuppliers";
import { getGlobalProductCode } from "../../../../helpers/global-product.helper";
import AuthContext from "../../../../context/AuthContext";
import { Predicates } from "../../../../libraries/predicates/predicates";
import { formatIntoOption } from "../../../../helpers/formatIntoOption";

export type SummaryProps = {
  selectedPM: ProductMaster | null;
  selectedGP: IGlobalProduct | null;
  selectedTcc: ITcc | null;
  savedSkuComposition: ISkuComposition;
  skuData: ISkuInformation;
  requestorMarket: IRequestorMarket;
  pisRequest: IPisRequest;
  tccComposition: ITccComposition[];
  selectedTccCompositionRegion: TccCompositionRegionInfo | null;
  isFinished: boolean;
};

const Summary = () => {

  const {state} = useCreateMpnStore()

  const [compositionHasHighlights, setCompositionHasHighlights] =
    useState<boolean>(false);

  const { data: linePlanningStatusConditions } =
    useLinePlanningStatusConditionsContext();

  // const { data: isSkuColorsDifferentFromTccColor } =
    // useCompareSkuColorsWithTccColor({
    //   shouldCheck:
    //     !isFinished && Predicates.isNotNullAndNotUndefined(selectedTcc),
    //   tccId: selectedTcc?.id ?? 0,
    //   skuColorsIds: getAllSkuComponentColors(savedSkuComposition),
    // });

    const authContext = useContext(AuthContext);
    const hasCanChangeFusionSupplierPermission = authContext?.hasPermission("api.can_change_fusion_suupplier")



  return (
    <>
      <div className="card card-header my-2 rounded d-flex justify-content-between">
        <h6 className="m-0 text-primary fw-bold">Summary</h6>
      </div>
      <div className="row">
        <div className="col-4">
          <label className="form-label">Request Status</label>
          <input
            value={state.mpnRequest.status}
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>
        <div className="col-4">
          <label className="form-label">Request nº</label>
          <input
            value={
              state.mpnRequest.pis_request_id
                ? state.mpnRequest.pis_request_id
                : "-"
            }
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>
        <div className="col-4">
          <label className="form-label">Revision nº</label>
          <input
            value={state.mpnRequest.revision}
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>
      </div>
      <div className="row mt-1">
        <div className="col-4">
          <label className="form-label">Request Location</label>
          <input
            value={`${state.requestorInfo.short_name}, ${state.requestorInfo.full_name}`}
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>
        <div className="col-2">
          <label className="form-label">Request Date</label>
          <input
            value={state.mpnRequest.request_date}
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>

        <div className="col-2">
          <label className="form-label">Requester</label>
          <input
            value={state.mpnRequest.requested_by ?? "-"}
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>

        <div className="col-2">
          <label className="form-label">{`${
            state.mpnRequest.status === "REJECTED" ? "Rejected" : "Approved"
          } Date`}</label>
          <input
            value={
              state.mpnRequest.status === "APPROVED" ||
              state.mpnRequest.status === "REJECTED"
                ? state.mpnRequest.dtchng ?? "-"
                : "-"
            }
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>

        <div className="col-2">
          <label className="form-label">Approver</label>
          <input
            value={
              state.mpnRequest.status === "APPROVED" ||
              state.mpnRequest.status === "REJECTED"
                ? state.mpnRequest.uidchng ?? "-"
                : "-"
            }
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>
      </div>
      <div className="row mt-1">
        <div className="col-2">
          <label className="form-label">MPN nº</label>
          <input
            value={
              state.mpnRequest.finish_goods_no_assigned
                ? `11 ${state.mpnRequest.finish_goods_no_assigned}`
                : "-"
            }
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>
        <div className="col-6">
          <label className="form-label">
            MPN Description <span className="red-text fw-bold">*</span>
          </label>
          <textarea
            value={state.mpnData.name}
            disabled={true}
            rows={1}
            className="form-control d-inline no-resize horizontal-scroll"
          />
        </div>

        {/*TODO: REIVEW THAT*/}
        <div className="col-4">
          <label className="form-label">Cloned from MPN</label>
          <textarea
            // value={
            //   selectedPM && selectedPM?.id && selectedPM?.description
            //     ? `11 ${selectedPM?.id} - ${selectedPM?.description?.trim()}`
            //     : "-"
            // }
            disabled={true}
            rows={1}
            className="form-control d-inline no-resize horizontal-scroll"
          />
        </div>
      </div>

      <div className="card card-header my-2 rounded d-flex justify-content-between">
        <h6 className="m-0 text-primary fw-bold">MPN Hierarchy</h6>
      </div>
      <div className="row">
        <div className="col-4">
          <label className="form-label">
            Category <span className="red-text fw-bold">*</span>
          </label>
          <textarea
            value={
              state.global_product
                ? `${state?.global_product?.sub_category?.parent?.code} - ${state?.global_product?.sub_category?.parent?.name}`
                : ""
            }
            disabled={true}
            rows={1}
            className="form-control d-inline no-resize horizontal-scroll"
          />
        </div>
        <div className="col-4">
          <label className="form-label">
            Sub-Category <span className="red-text fw-bold">*</span>
          </label>
          <textarea
            value={
              state.global_product
                ? `${state?.global_product?.sub_category?.code} - ${state?.global_product?.sub_category?.name}`
                : ""
            }
            disabled={true}
            rows={1}
            className="form-control d-inline no-resize horizontal-scroll"
          />
        </div>
        <div className="col-4">
          <label className="form-label">
            Product Line <span className="red-text fw-bold">*</span>
          </label>
          <textarea
            value={
              state.global_product
                ? `${state?.global_product?.product_line?.code} - ${state?.global_product?.product_line?.name}`
                : ""
            }
            disabled={true}
            rows={1}
            className="form-control d-inline no-resize horizontal-scroll"
          />
        </div>
      </div>
      <div className="row mt-1">
        <div className="col-6">
          <label className="form-label">
            Global Product <span className="red-text fw-bold">*</span>
          </label>
          {/*{selectedGP ? (*/}
          {/*  <ButtonIconModal*/}
          {/*    buttonIconClass="mx-3 d-inline-block"*/}
          {/*    description="show attributes"*/}
          {/*    title={`Global Product ${*/}
          {/*      formatGlobalProductIntoOption(selectedGP).label*/}
          {/*    }`}*/}
          {/*    icon={faCirclePlus}*/}
          {/*    iconClass="me-2"*/}
          {/*  >*/}
          {/*    <GlobalProductTemplate model={selectedGP} />*/}
          {/*  </ButtonIconModal>*/}
          {/*) : (*/}
          <></>
          {/*)}*/}
          <textarea
            value={
              state.global_product?.gpc_gpcode
                ? `${state?.global_product?.gpc_gpcode} - ${state?.global_product?.name}`
                : `${getGlobalProductCode(state?.global_product)} - ${state?.global_product?.name}`
            }
            disabled={true}
            rows={1}
            className="form-control d-inline no-resize horizontal-scroll"
          />
        </div>

        <div className="col-6">
          <label className="form-label">Item Number </label>
          {/*{selectedTcc ? (*/}
          {/*  <>*/}
          {/*    <ButtonIconModal*/}
          {/*      buttonIconClass="mx-3 d-inline-block"*/}
          {/*      description="show attributes"*/}
          {/*      title={`TCC ${formatTccIntoOption(selectedTcc).label}`}*/}
          {/*      icon={faCirclePlus}*/}
          {/*      iconClass="me-2"*/}
          {/*    >*/}
          {/*      <TCCTemplate tccId={selectedTcc.id} />*/}
          {/*    </ButtonIconModal>*/}

          {/*    <ButtonIconModal*/}
          {/*      buttonIconClass="mx-3 d-inline-block"*/}
          {/*      description="show picture"*/}
          {/*      title={`TCC ${formatTccIntoOption(selectedTcc).label}`}*/}
          {/*      icon={faImage}*/}
          {/*      iconClass="me-2"*/}
          {/*    >*/}
          {/*      <PictureModal src={selectedTcc.product_photo} />*/}
          {/*    </ButtonIconModal>*/}
          {/*  </>*/}
          {/*) : (*/}
          <></>
          {/*)}*/}
          <textarea
            value={
              state?.itemNumber?.itn_itemno
                ? `${state?.itemNumber?.itn_itemno} - ${state?.itemNumber?.name}`
                : ""
            }
            disabled={true}
            rows={1}
            className="form-control d-inline no-resize horizontal-scroll"
          />
        </div>
      </div>
      <div className="card card-header my-2 rounded d-flex flex-row justify-content-start align-items-center">
        <h6 className="m-0 text-primary fw-bold">{`MPN Composition `}</h6>
        {/*{compositionHasHighlights &&*/}
        {/*  !selectedTccCompositionRegion?.is_restrictive && (*/}
        {/*    <span className="ml-2 font-italic">*/}
        {/*      (The values highlighted in yellow are different from the TCC data)*/}
        {/*    </span>*/}
        {/*  )}*/}
        {/*{compositionHasHighlights &&*/}
        {/*  selectedTccCompositionRegion?.is_restrictive && (*/}
        {/*    <span className="ml-2 font-italic">*/}
        {/*      (The colors highlighted in yellow are different from the TCC data*/}
        {/*      for the respective mold / sequence)*/}
        {/*    </span>*/}
        {/*  )}*/}
      </div>

      {!isMpnCompositionEmpty(state.composition) && (
        <MpnCompositionTree
          composition={state.composition}
          isSummaryPage={true}
          isMainPage={false}
          shouldIncludeSku={false}
          manageSkuInclusion={() => {}}
          manageComponentInclusion={() => {}}
          assertComponentIsIncluded={() => {}}
          // tccComposition={
          //   Predicates.isNotNullAndNotUndefined(selectedTccCompositionRegion)
          //     ? tccComposition
          //     : []
          // }
          // highlightsCheckType={
          //   selectedTccCompositionRegion?.is_restrictive
          //     ? "restrictive"
          //     : "not-restrictive"
          // }
          setCompositionHasHighlights={() => setCompositionHasHighlights(true)}
        />
      )}

      {/*{!isFinished && isSkuColorsDifferentFromTccColor ? (*/}
      {/*  <Banner*/}
      {/*    classname="mt-3"*/}
      {/*    message={*/}
      {/*      "There are components colors different from the selected TCC product color."*/}
      {/*    }*/}
      {/*    type="warning"*/}
      {/*  />*/}
      {/*) : (*/}
      {/*  <></>*/}
      {/*)}*/}

      {/*<ExpandableSection*/}
      {/*  title={`TCC Data ${tccComposition.length > 0 && Predicates.isNotNullAndNotUndefined(selectedTccCompositionRegion) ? `(${selectedTccCompositionRegion.region.name} - ${selectedTccCompositionRegion.is_restrictive ? "Restrictive" : "Not Restrictive"})` : ""}`}*/}
      {/*  sectionId={"tcc-values"}*/}
      {/*  className="mb-2"*/}
      {/*  expandedByDefault*/}
      {/*>*/}
      {/*  {tccComposition.length > 0 && (*/}
      {/*    <TccValuesImportTable*/}
      {/*      tccComposition={tccComposition}*/}
      {/*      selectedRowsIds={[]}*/}
      {/*      selectedMoldIndexes={[]}*/}
      {/*      setSelectedCompositionRows={() => {}}*/}
      {/*      setUsedMoldIndexes={() => {}}*/}
      {/*      setChangedImportValues={() => {}}*/}
      {/*      isInApprovalProcess={true}*/}
      {/*      isRevision={Number(pisRequest.revision) > 0}*/}
      {/*      isSummaryPage*/}
      {/*    />*/}
      {/*  )}*/}
      {/*</ExpandableSection>*/}
      <div className="card card-header my-2 rounded d-flex justify-content-between">
        <h6 className="m-0 text-primary fw-bold">MPN Information</h6>
      </div>
      <div className="mt-1">
        <div className="row align-items-end">
          <div className="col-3">
            <label className="form-label">
              Release Date <span className="red-text fw-bold">*</span>
            </label>
            <input
              value={state.mpnData?.reldt ? state.mpnData?.reldt : "-"}
              type="text"
              className="form-control d-inline"
              disabled={true}
            />
          </div>

          <div className="col-3">
            <label className="form-label ">
              Product Use <span className="red-text fw-bold">*</span>
            </label>
            <input
              value={state.mpnData?.product_use}
              type="text"
              className="form-control d-inline"
              disabled={true}
            />
          </div>

          <div className="col-3">
            <label className="form-label">
              Gift Box <span className="red-text fw-bold">*</span>
            </label>
            <input
              value={state.mpnData?.giftbox === "N" ? "No" : "Yes"}
              type="text"
              className="form-control d-inline"
              disabled={true}
            />
          </div>

          <div className="col-3">
            <label className="form-label">Project ID</label>
            <input
              value={state.mpnData?.project_id}
              type="text"
              className="form-control d-inline"
              disabled={true}
            />
          </div>
        </div>
      </div>

      <div className="row mt-1">
        <div className={"col-4"}>
          <label className="form-label">
            TPS Product <span className="red-text fw-bold">*</span>
          </label>
          <input
            value={state.mpnData?.tps_product === "N" ? "No" : "Yes"}
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>

            <div className="col-4">
              <label className="form-label">
                Vendor
                {state.mpnData?.tps_product === "Y" && (
                  <span className="red-text fw-bold"> *</span>
                )}
              </label>
              <input
                value={
                  state.mpnData?.tps_loc_id &&
                  state.mpnData?.tps_loc_id.id !== "0"
                    ? formatSupplierCountryIntoOption(state.mpnData?.tps_loc_id)
                        .label
                    : "-"
                }
                type="text"
                className="form-control d-inline"
                disabled={true}
              />
            </div>
            <div className="col-4">
              <label className="form-label">
                TPS Type
                {state.mpnData?.tps_product === "Y" && (
                  <span className="red-text fw-bold"> *</span>
                )}
              </label>
              <input
                value={
                  state.mpnData?.tps_type_id &&
                  state.mpnData?.tps_type_id.res_pis_type_id !== "0"
                    ? formatTpsTypeIntoOption(state.mpnData?.tps_type_id).label
                    : "-"
                }
                type="text"
                className="form-control d-inline"
                disabled={true}
              />
            </div>

      </div>
      {hasCanChangeFusionSupplierPermission &&
            <div className="col-6">
              <label className="form-label">
                Fusion Supplier <span className="red-text fw-bold">*</span>
              </label>
              <input
                  value={
              Predicates.isNotNullAndNotUndefinedAndNotEmpty(
                state.fusionSupplier?.id,
              )
                ? formatIntoOption<any>(state.fusionSupplier, {
                    keys: ["supplier_code", "supplier_name"],
                  })?.label
                : ""
            }
                type="text"
                className="form-control d-inline"
                disabled={true}
              />
            </div>
      }

      <div className="row mt-1">
        <div className="col-md-4 form-group">
          <label className="form-label">
            {PRODUCTION_STATUS_LABEL}{" "}
            {/*{Number(pisRequest.revision) > 0 && (*/}
            {/*  <span className="red-text fw-bold">*</span>*/}
            {/*)}*/}
          </label>
          <input
            value={
              state.mpnData?.production_lifecycle_status
                ? state.mpnData?.production_lifecycle_status
                : ""
            }
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>

        <div className="col-md-4 form-group">
          <label className="form-label">
            {SALES_STATUS_LABEL} {/*{Number(pisRequest.revision) > 0 && (*/}
            {/*  <span className="red-text fw-bold">*</span>*/}
            {/*)}*/}
          </label>
          <input
            value={
              state.mpnData?.sales_lifecycle_status
                ? state.mpnData?.sales_lifecycle_status
                : ""
            }
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>

        <div className="col-md-4 form-group">
          <Tooltip
            id="line-status"
            className="tooltip-text-box"
            place="right"
            noArrow={true}
          />
          <label className="form-label">{LIFECYCLE_STATUS_LABEL}</label>
          <span
            className="tooltip-span"
            data-tooltip-id="line-status"
            data-tooltip-html={`The ${LIFECYCLE_STATUS_LABEL.toLowerCase()} results from the combination of <br/> the ${PRODUCTION_STATUS_LABEL.toLowerCase()} and ${SALES_STATUS_LABEL.toLowerCase()}.`}
          >
            <FontAwesomeIcon icon={faCircleInfo} className="tooltip-icon" />
          </span>
          <input
            value={calculateLinePlanningStatus(
              linePlanningStatusConditions,
              state.mpnData?.production_lifecycle_status,
              state.mpnData?.sales_lifecycle_status,
            )}
            type="text"
            className="form-control"
            disabled={true}
          />
        </div>
      </div>

      <div className="row mt-1 align-items-end">
        <div className="col-4">
          <label className="form-label">Product Gross Weight (g)</label>
          <div className="d-flex align-items-center">
            <input
              value={state.mpnData?.pgrwgt}
              type="text"
              className="form-control d-inline"
              disabled={true}
            />
          </div>
        </div>

        <div className="col-4">
          <label className="form-label">Product Net Weight (g)</label>
          <div className="d-flex align-items-center">
            <input
              value={state.mpnData?.pntwgt}
              type="text"
              className="form-control d-inline"
              disabled={true}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="pb-1">
            <div className="label-3 bottom-border">
              <label className="form-label">
                <strong> Product Dimension</strong>
              </label>
            </div>
          </div>
          <div className="d-flex">
            <div className="col-4 label-3 pl-0">
              <label className="form-label">L (mm)</label>
              <input
                value={state.mpnData?.length}
                type="text"
                className="form-control d-inline"
                disabled={true}
              />
            </div>
            <div className="col-4 label-3">
              <label className="form-label">W (mm)</label>
              <input
                value={state.mpnData?.width}
                type="text"
                className="form-control d-inline"
                disabled={true}
              />
            </div>
            <div className="col-4 label-3 pr-0">
              <label className="form-label">H (mm)</label>
              <input
                value={state.mpnData?.height}
                type="text"
                className="form-control d-inline"
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-1">
        <div className="col">
          <label className="form-label">Comment</label>
          <textarea
            value={state.mpnData?.comments}
            rows={numberOfTextAreaRows(state.mpnData?.comments?.split("\n"))}
            className="form-control d-inline"
            disabled={true}
          />
        </div>
      </div>

      <div className="card card-header my-2 rounded d-flex justify-content-between">
        <h6 className="m-0 text-primary fw-bold">Product Packaging</h6>
      </div>
      <div className="row align-items-end mt-1 justify-content-between mb-2">
        <div className="col-2">
          <label className="form-label ">
            Standard Pack <span className="red-text fw-bold">*</span>
          </label>
          <input
            value={state.mpnData?.stdpk}
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>

        <div className="col-3">
          <label className="form-label">
            Standard Pack Gross Weight (kg){" "}
            <span className="red-text fw-bold">*</span>
          </label>
          <input
            value={state.mpnData?.stdpk_weight}
            type="text"
            className="form-control d-inline"
            disabled={true}
          />
        </div>

        <div className="col-3">
          <label className="form-label">Standard Pack Net Weight (kg)</label>
          <div className="d-flex align-items-center">
            <input
              value={state.mpnData?.cntwgt}
              type="text"
              className="form-control d-inline"
              disabled={true}
            />
          </div>
        </div>

        <div className="col-4">
          <div className="row pb-1 ">
            <div className="col label-3 bottom-border">
              <label className="form-label ">
                <strong> Standard Pack Size </strong>
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-4 label-3">
              <label className="form-label">
                L (mm) <span className="red-text fw-bold">*</span>
              </label>
              <input
                value={state.mpnData?.stdpk_length}
                type="text"
                className="form-control d-inline"
                disabled={true}
              />
            </div>
            <div className="col-4 label-3">
              <label className="form-label">
                W (mm) <span className="red-text fw-bold">*</span>
              </label>
              <input
                value={state.mpnData?.stdpk_width}
                type="text"
                className="form-control d-inline"
                disabled={true}
              />
            </div>
            <div className="col-4 label-3">
              <label className="form-label ">
                H (mm) <span className="red-text fw-bold">*</span>
              </label>
              <input
                value={state.mpnData?.stdpk_height}
                type="text"
                className="form-control d-inline"
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Summary;